Controller.$inject = [];

function Controller() {
}

export function HuiButtonGroup() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: `
            <div class="hui hui-button-group" ng-transclude></div>
        `
    }
}